import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "flex flex-col m-2 w-1/4" };
const _hoisted_2 = { class: "capitalize text-primary font-bold overflow-ellipsis overflow-hidden whitespace-nowrap" };
const _hoisted_3 = { class: "py-3" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", { class: "text-primary font-semibold mb-2" }, "Logo", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_6 = { class: "text-primary text-sm font-light" };
const _hoisted_7 = { class: "flex flex space-x-6 items-center" };
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-plus mr-2" }, null, -1);
const _hoisted_10 = { class: "py-3" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("span", { class: "text-primary font-semibold mb-2" }, "Favicon", -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_13 = { class: "text-primary text-sm font-light" };
const _hoisted_14 = { class: "flex flex space-x-6 items-center" };
const _hoisted_15 = ["src"];
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-plus mr-2" }, null, -1);
const _hoisted_17 = { class: "py-3" };
const _hoisted_18 = { class: "text-primary font-semibold" };
const _hoisted_19 = { class: "flex flex-row mt-2" };
const _hoisted_20 = {
    class: "flex flex-row border-gray-300 border-solid border rounded",
    ref: "companyNameInput"
};
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-times hover:text-black text-xs text-gray-300" }, null, -1);
const _hoisted_22 = [
    _hoisted_21
];
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-check mr-2" }, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Button = _resolveComponent("Button");
    const _component_image_preview_modal = _resolveComponent("image-preview-modal");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('settings.brandingTitle')), 1),
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('settings.logoSubtitle')), 1),
                _createElementVNode("div", _hoisted_7, [
                    (_openBlock(), _createElementBlock("img", {
                        key: _ctx.config.logo,
                        class: "h-24 h-24 my-2",
                        alt: "vault-logo",
                        src: _ctx.config.logo
                    }, null, 8, _hoisted_8)),
                    _createVNode(_component_Button, {
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.clickLogoInput(_ctx.brandingImage.LOGO)))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_9,
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('forms.buttons.uploadFile')), 1)
                        ]),
                        _: 1
                    })
                ])
            ]),
            _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('settings.faviconSubtitle')), 1),
                _createElementVNode("div", _hoisted_14, [
                    (_openBlock(), _createElementBlock("img", {
                        key: _ctx.config.favicon,
                        class: "h-24 h-24 my-2",
                        alt: "Favicon",
                        src: _ctx.config.favicon
                    }, null, 8, _hoisted_15)),
                    _createVNode(_component_Button, {
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.clickLogoInput(_ctx.brandingImage.FAVICON)))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_16,
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('forms.buttons.uploadFile')), 1)
                        ]),
                        _: 1
                    })
                ])
            ]),
            _createElementVNode("form", {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"])),
                ref: "formInput"
            }, [
                _createElementVNode("input", {
                    id: "imageInput",
                    ref: "imageInput",
                    onChange: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_ctx.logoSelected && _ctx.logoSelected(...args))),
                    class: "hidden",
                    type: "file",
                    accept: "image/jpeg, image/png"
                }, null, 544)
            ], 544),
            _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('settings.companyName')), 1),
                _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                            class: "pl-3 items-center text-sm flex flex-grow justify-items-center focus:outline-none border-0 my-0 py-0",
                            placeholder: "Company Name",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.settings.companyName) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.settings.companyName]
                        ]),
                        _createElementVNode("div", {
                            onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.settings.companyName = '')),
                            class: "px-2 flex flex-row items-center justify-center cursor-pointer"
                        }, _hoisted_22)
                    ], 512),
                    _createVNode(_component_Button, {
                        onClick: _ctx.pushSettings,
                        class: "w-max ml-2",
                        colored: ""
                    }, {
                        default: _withCtx(() => [
                            _hoisted_23,
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('forms.buttons.save')), 1)
                        ]),
                        _: 1
                    }, 8, ["onClick"])
                ])
            ])
        ]),
        (_ctx.showPreviewModal)
            ? (_openBlock(), _createBlock(_component_image_preview_modal, {
                key: 0,
                preview: _ctx.imagePreview,
                type: _ctx.imageType,
                show: _ctx.showPreviewModal,
                "onUpdate:show": _cache[6] || (_cache[6] = ($event) => ((_ctx.showPreviewModal) = $event)),
                onUploadLogo: _ctx.downscaledToFile
            }, null, 8, ["preview", "type", "show", "onUploadLogo"]))
            : _createCommentVNode("", true)
    ], 64));
}
